// packConfig.js
export const packConfig = {
  PackUltraOne :[
    {
      
      image: "Pack_Ultra_one.jpg",
      name: "Pack Ultra One",
      description: "Description du Pack Ultra One",
    },
     {
      
      image: "Pack_Ultra_2.jpg",
      name: "Pack Ultra 2",
      description: "Description du Pack Ultra 2",
    },
     {
      
      image: "Pack_Ultra_3.jpg",
      name: "Pack Ultra 3",
      description: "Description du Pack Ultra 3",
    },
     {
      
      image: "Pack_Ultra_4.jpg",
      name: "Pack Ultra 4",
      description: "Description du Pack Ultra 4",
    }
  ], 

    PackABIR :[
    {
      
      image: "Pack_A_Air_Pro.", 
      name: "Pack A Air Pro",
      description: "Description Pack A Air Pro",
    },
     {
      
      image: "Pack_B_Air_Max.jpg",
      name: "Pack B Air Max",
      description: "Description du Pack B Air Max",
    },
     {
      
      image: "Pack_I_Air_Ultra.jpg",
      name: "Pack I Air Ultra",
      description: "Description du Pack I Air Ultr",
    },
     {
      
      image: "Pack_R_Air_Force.jpg",
      name: "Pack R Air Force",
      description: "Description du Pack R Air Force",
    }
  ],


  PackNVPU: [
    {
      image: "pack_N.jpg",
      name: "Pack N",
      description: "Description du Pack N",
    },
    {
      image: "pack_V.jpg",
      name: "Pack V",
      description: "Description du Pack V",
    },
    {
      image: "pack_P.jpg",
      name: "Pack P",
      description: "Description du Pack P",
    },
    {
      image: "pack_U.jpg",
      name: "Pack U",
      description: "Description du Pack U",
    },
  ],
  PackSXMG: [
    {
      image: "pack_S.jpg",
      name: "Pack S",
      description: "Description du Pack S",
    },
    {
      image: "pack_X.jpg",
      name: "Pack X",
      description: "Description du Pack X",
    },
    {
      image: "pack_M.jpg",
      name: "Pack M",
      description: "Description du Pack M",
    },
    {
      image: "pack_G.jpg",
      name: "Pack G",
      description: "Description du Pack G",
    },
  ],

  PackSXMGsp: [
    {
      image: "pack_S_specialEdition.jpg",
      name: "Pack S (special edition)",
      description: "Description du Pack S",
    },
    {
      image: "pack_X_specialEdition.jpg",
      name: "Pack X (special edition)",
      description: "Description du Pack X",
    },
    {
      image: "pack_M_specialEdition.jpg",
      name: "Pack M (special edition)",
      description: "Description du Pack M",
    },
    {
      image: "pack_G_specialEdition.jpg",
      name: "Pack G (special edition)",
      description: "Description du Pack G",
    },
  ],
  PackAJKQ: [
    {
      image: "pack_A.jpg",
      name: "Pack A",
      description: "Description du Pack A",
    },
    {
      image: "pack_J.jpg",
      name: "Pack J",
      description: "Description du Pack J",
    },
    {
      image: "pack_K.jpg",
      name: "Pack K",
      description: "Description du Pack K",
    },

    {
      image: "pack_Q.jpg",
      name: "Pack Q",
      description: "Description du Pack Q",
    },
  ],

  PackRRRR: [
    {
      image: "pack_R1.jpg",
      name: "Pack R1",
      description: "Description du Pack R1",
    },
    {
      image: "pack_R2.jpg",
      name: "Pack R2",
      description: "Description du Pack R2",
    },
    {
      image: "pack_R3.jpg",
      name: "Pack R3",
      description: "Description du Pack R3",
    },
    {
      image: "pack_R4.jpg",
      name: "Pack R4",
      description: "Description du Pack R4",
    },
  ],
   PackRS: [
    {
      image: "pack_R1.jpg",
      name: "Pack Rs Air",
      description: "Description du Pack Rs Air",
    },
    {
      image: "pack_R2.jpg",
      name: "Pack Rs Air Pro",
      description: "Description du Pack Rs Air Pro",
    },
    {
      image: "pack_R3.jpg",
      name: "Pack Rs Air Max",
      description: "Description du Pack Rs Air Max",
    },
    {
      image: "pack_R4.jpg",
      name: "Pack Rs Air Ultra",
      description: "Description du Pack Rs Air Ultra",
    },
  ],

  PackTD: [
    {
      image: "pack_Pro.jpg ",
      name: "Pack TD Pro",
      description: "Description du Pack Pro",
    },
    {
      image: "pack_Ultra.jpg ",
      name: "Pack TD Ultra",
      description: "Description du Pack Ultra",
    },
       {
      image: "pack_Ai_Ultra.jpg ",
      name: "Pack MWG Ai ULTRA",
      description: "Description du Pack Ai Ultra",
    },
     {
      image: "pack_Halcon.jpg ",
      name: "Pack Halcon",
      description: "Description du Pack Halcon",
    }
 
   
  ],
};
